/* URBAN MODESTY — TECH LAYER
   1. Instant navigation: Speculation Rules prerendering (Chromium)
      with a hover/touch prefetch fallback (Safari, Firefox)
   2. Add-to-cart micro-interactions: button morph, cart bump,
      fly-to-cart dot, light haptic tap
   3. Native Web Share on product pages
   4. Respect for Save-Data / prefers-reduced-motion (pauses hero videos)
*/
(function () {
  'use strict';

  var conn = navigator.connection || {};
  var saveData = conn.saveData === true;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------
     1a. Speculation Rules — prerender product & collection pages
         the moment the visitor shows intent (Chromium 121+).
  ----------------------------------------------------------------*/
  function initSpeculationRules() {
    if (saveData) return;
    if (!(window.HTMLScriptElement &&
          HTMLScriptElement.supports &&
          HTMLScriptElement.supports('speculationrules'))) {
      return;
    }
    var rules = {
      prerender: [{
        where: {
          and: [
            { href_matches: ['/products/*', '/collections/*'] },
            { not: { href_matches: ['/*\\?*variant=*'] } },
            { not: { selector_matches: '[data-no-prerender]' } }
          ]
        },
        eagerness: 'moderate'
      }],
      prefetch: [{
        where: { href_matches: ['/pages/*', '/blogs/*'] },
        eagerness: 'moderate'
      }]
    };
    var script = document.createElement('script');
    script.type = 'speculationrules';
    script.textContent = JSON.stringify(rules);
    document.head.appendChild(script);
  }

  /* ---------------------------------------------------------------
     1b. Prefetch fallback for browsers without speculation rules.
         On hover/touchstart, prefetch the document once.
  ----------------------------------------------------------------*/
  function initHoverPrefetch() {
    if (saveData) return;
    if (window.HTMLScriptElement &&
        HTMLScriptElement.supports &&
        HTMLScriptElement.supports('speculationrules')) {
      return; // Chromium path already active
    }
    var seen = {};
    var count = 0;
    var MAX = 40;

    function prefetch(url) {
      if (seen[url] || count >= MAX) return;
      seen[url] = true;
      count++;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = url;
      link.as = 'document';
      document.head.appendChild(link);
    }

    function onIntent(evt) {
      var a = evt.target.closest && evt.target.closest('a[href^="/"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      if (!/^\/(products|collections)\//.test(href)) return;
      if (href.indexOf('?') !== -1) return;
      prefetch(a.href);
    }

    document.addEventListener('mouseover', onIntent, { passive: true });
    document.addEventListener('touchstart', onIntent, { passive: true });
  }

  /* ---------------------------------------------------------------
     2. Add-to-cart micro-interactions
  ----------------------------------------------------------------*/
  function initAtcFeedback() {
    var lastAtcButton = null;

    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest &&
        evt.target.closest('[data-add-to-cart], [data-um-sticky-btn], [data-um-quick-add]');
      if (btn) lastAtcButton = btn;
    }, true);

    document.addEventListener('ajaxProduct:added', function () {
      bumpCartIcon();
      if (!reducedMotion && lastAtcButton) flyToCart(lastAtcButton);
      if (navigator.vibrate && !reducedMotion) {
        try { navigator.vibrate(12); } catch (e) {}
      }
    });

    function bumpCartIcon() {
      var icon = document.querySelector('.js-drawer-open-cart .cart-link') ||
                 document.querySelector('.js-drawer-open-cart');
      if (!icon) return;
      icon.classList.remove('um-cart-bump');
      // Force reflow so the animation can replay
      void icon.offsetWidth;
      icon.classList.add('um-cart-bump');
    }

    function flyToCart(fromEl) {
      var target = document.querySelector('.js-drawer-open-cart');
      if (!target) return;
      var from = fromEl.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || !to.width) return;

      var dot = document.createElement('span');
      dot.className = 'um-fly-dot';
      dot.style.left = (from.left + from.width / 2) + 'px';
      dot.style.top = (from.top + from.height / 2) + 'px';
      document.body.appendChild(dot);

      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

      var anim = dot.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.5 + 'px, ' + (dy - 60) + 'px) scale(0.9)', opacity: 1, offset: 0.6 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(0.25)', opacity: 0.4 }
      ], { duration: 650, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)' });

      anim.onfinish = function () { dot.remove(); };
    }
  }

  /* ---------------------------------------------------------------
     3. Native share sheet on product pages
  ----------------------------------------------------------------*/
  function initWebShare() {
    if (!navigator.share) return;
    // Only take over on touch devices — desktop users may want a
    // specific network, mobile users get the native share sheet.
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    var sharing = document.querySelector('.product-single__meta .social-sharing, .social-sharing');
    if (!sharing) return;

    sharing.addEventListener('click', function (evt) {
      var link = evt.target.closest && evt.target.closest('a');
      if (!link) return;
      evt.preventDefault();
      navigator.share({
        title: document.title,
        url: window.location.href
      }).catch(function () {});
    });
  }

  /* ---------------------------------------------------------------
     4. Data & motion respect — pause autoplaying hero videos for
        visitors on Save-Data or reduced motion.
  ----------------------------------------------------------------*/
  function initMediaRespect() {
    if (!saveData && !reducedMotion) return;
    document.querySelectorAll('video.video-div, .hero__media video').forEach(function (video) {
      try {
        video.pause();
        video.removeAttribute('autoplay');
        video.preload = 'none';
      } catch (e) {}
    });
  }

  function init() {
    initSpeculationRules();
    initHoverPrefetch();
    initAtcFeedback();
    initWebShare();
    initMediaRespect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
